import React from "react";
/* Select — Phase B primitive.
   Native <select> styled to match <Input>. Used for the language switcher
   (per IA.md F57 decision — "EN ▾" dropdown ready for >2 languages).

   options: Array<{ id, label, disabled? }>
   size:    sm | md (default)
*/

export default function Select({
  size = "md",
  value,
  options = [],
  onChange,
  disabled = false,
  error = null,
  className = "",
  rawEvent = false,
  ...rest
}) {
  const handleChange = (e) => {
    if (typeof onChange !== "function") return;
    onChange(rawEvent ? e : e.target.value);
  };
  const cls = [
    "v2-input",
    `v2-input--${size}`,
    "v2-input--select",
    error ? "v2-input--error" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <select
      value={value == null ? "" : value}
      onChange={handleChange}
      disabled={disabled}
      className={cls}
      aria-invalid={error ? true : undefined}
      {...rest}
    >
      {options.map(o => (
        <option key={o.id} value={o.id} disabled={o.disabled}>{o.label}</option>
      ))}
    </select>
  );
}
